
  import { Component, OnInit, ViewChild } from '@angular/core';
  import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../services/_services';
  import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
  import { DataTableDirective } from 'angular-datatables';
  import { Subject } from 'rxjs';
  import { Router, Route, ActivatedRoute } from "@angular/router";
  import { FormBuilder, FormGroup, Validators } from '@angular/forms';
  import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';

  import Swal from 'sweetalert2';

  declare var document,$;

  @Component({
    selector: 'app-progress-requests',
    templateUrl: './progress-requests.component.html',
    styleUrls: ['./progress-requests.component.css']
  })
  export class ProgressRequestsComponent implements OnInit {
      @ViewChild('myPond') myPond: any

        public despositionArray   : any = AppSettings.disposition;
        public documentTypeArray  : any = AppSettings.documentType;
        public loading            : any = false;
        public paginatePage       : any;
        public leads              : any = [];
        public comments           : any = [];
        public agentComments      : any = [];
        public qaComments         : any = [];
        public agentsSub          : any;
        public agents             : any;
        public qa                 : any;
        public loader             : any;
        public statusArr          : any = [
                                            { name: 'Pending',    value: 0 },
                                            { name: 'Completed',  value: 1 },
                                          ];


        @ViewChild(DataTableDirective)
        public dtElement               : DataTableDirective;
        public dtOptions               : DataTables.Settings = {};
        public dtTrigger               : any = new Subject();

        public searchParams            : any = { email : '', status: 0 };
        public fullRangeDate           : any;
        public selectedDesposition     : any;
        public routeSaver              : any;
        public base64Pipe              : any = new Base64Pipe;

        pondOptions1 = {
          allowMultiple: true,
          labelIdle: ` <p class='pond-label'> Drag & drop or <span> browse </span></p>`,
          allowImagePreview: true,
        }
        pondFiles = []

        constructor(
          private helperService       : HelperService,
          private activatedRoute      : ActivatedRoute,
          private router              : Router,
          private agentsService       : Agents,
        ) {

          this.routeSaver = this.router.url;

            this.dtOptions = {
              paging: true,
              info: true,
              // ordering: false,
              pagingType: 'full_numbers',
              pageLength: 10,
              serverSide: true,
              processing: true,
              searching: false,
              'language': AppSettings.dataTableLang,
              "columnDefs": [
                { "orderable": false,                           "targets": 0 },
                { "orderable": false,                           "targets": 1 },
                { "orderable": false,                           "targets": 2 },
                { "orderable": false,                           "targets": 3 },
                { "orderable": false,                           "targets": 4 },
              ],
              "order": [[ 1, "desc" ]],
              ajax: (dataTablesParameters: any, callback) => {
                // Show Loader
                this.loading = true;
                // console.log("dataTablesParameters", dataTablesParameters);

                let url  = AppSettings.API_ENDPOINT + 'support/progress-requests';

                let dtParams = {
                                email                : this.searchParams.email,
                                status               : this.searchParams.status,
                                start                : dataTablesParameters.start,
                                length               : dataTablesParameters.length,
                                order                : dataTablesParameters.order,
                                columns              : dataTablesParameters.columns
                              };

                // For Record Serial Numbers
                this.paginatePage = dataTablesParameters.start;
                this.leads.data = [];
                this.helperService.httpPostRequestsDecryp(url, dtParams)
                  .then( resp => {
                      this.leads        = JSON.parse(resp);

                      // console.log("this.leads", this.leads);

                      // Set Default page len
                      this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                      // Hide Loader
                      this.loading = false;

                      callback({
                        recordsTotal: this.leads.total,
                        recordsFiltered: this.leads.total,
                        // recordsFiltered: resp['recordsFiltered'],
                        // recordsFiltered: 1000,
                        data: []
                      });

                      // // $(".paginate_button .current").css("color", "white");
                      // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                      $('div.dataTables_length select').addClass('dt-form-control');
                      $('div.dataTables_filter input').addClass('dt-form-control');
                  })
                  .catch(error => {
                      // Set loader false
                      this.loading = false;

                      // // Rerender DT in case of failure
                      // this.rerender();

                      console.log("error: ",error);
                  });
              },
              columns: [
                // { data: 'multiDelete' },
                { data: 'sr' },
                { data: 'order_id' },
                { data: 'date' },
                { data: 'complete_request' },
                { data: 'status' },
              ],
              // Use this attribute to enable the responsive extension
              responsive: false
            }

        }



        ngOnInit() {

        }

        ngAfterViewInit(){
          this.dtTrigger.next();
        }

        ngOnDestroy(): void {
          // Do not forget to unsubscribe the event
          this.dtTrigger.unsubscribe();
          if (typeof this.agentsSub != 'undefined') {
            //prevent memory leak when component destroyed
            this.agentsSub.unsubscribe();
          }
        }

        rerender(): void {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

            // Destroy the table first
            dtInstance.destroy();

            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
          });
        }

        updateStatus(lead, index) {
          // Show Status Loader
          // this.leads.data[index].updatingStatus = true;

          let url = AppSettings.API_ENDPOINT + "shared/update-request-status";
          let data = { progress_id: lead.id, status: lead.status };
          console.log("data", data);
          this.helperService.httpPostRequests(url, data).then(resp => {
              console.log("resp", resp);

            if(typeof resp != "undefined" && resp.status == "OK") {
              Swal.fire('', resp.message, 'success');
            }
          });
        }

        clearFilters(){
          this.searchParams = { email : '', status: 0 };

          this.rerender();
        }

    }
